<template>
      <main>
        <loading-container :loading="loading" @loaded="init">
          <div class="body">
            <div class="top">
              <div class="top__title column">
                <div class="name">
                  Об организации
                </div>
                <div class="top__title-radio">
                  <div
                      class="top__title-radio-item"
                      v-for="(item) in tabs"
                      :class="{ active: entity.type == item.key }"
                      :key="item.key + 'or'"
                      @click="tabActive(item.key)"
                  >
                    {{item.title}}
                  </div>
                </div>
              </div>
              <div class="top__title column">
                <div class="name">
                  Руководитель {{entity.type == 1 ? 'организации' : 'ИП'}}
                </div>
              </div>
              <div class="top__title column right">
                <div class="top__title-radio">

                  <div
                      class="top__title-radio-item"
                      v-for="(item) in tab"
                      :class="{active: entity.active == item.key}"
                      :key="item.key + 'act'"
                      @click="entity.active = item.key"
                  >
                    {{item.title}}
                  </div>
                </div>
              </div>
            </div>
            <div class="content">
              <div class="column">
                <h4>{{entity.type == 1 ? 'Юридическое название компании*' : 'Индивидуальный предприниматель*'}}</h4>
                <div class="input-block">
                  <input autocomplete="off" type="text" name="company_name" v-model="entity.company_name" v-validate="'required'" data-vv-validate-on="blur">
                  <span class="text-danger text-sm">{{ errors.first('company_name') }}</span>
                </div>
                <h4>ИНН*</h4>
                <div class="input-block">
                  <input autocomplete="off" type="number" @keyup="changeInn()" name="inn" v-model="entity.inn" v-validate="`length:${entity.type == 1 ? 10 : 12}|required`" data-vv-validate-on="blur">
                  <span class="text-danger text-sm">{{ errors.first('inn') }}</span>
                </div>
                <h4 v-if="entity.type == 1">КПП*</h4>
                <div class="input-block" v-if="entity.type == 1">
                  <input autocomplete="off" type="number" name="kpp" v-model="entity.kpp" v-validate="'length:9|required'" data-vv-validate-on="blur">
                  <span class="text-danger text-sm">{{ errors.first('kpp') }}</span>
                </div>
                <h4>{{entity.type == 2 ? 'ОГРНИП*' : 'ОГРН*'}}</h4>
                <div class="input-block" :key="entity.type">
                  <input autocomplete="off" type="number" :name="entity.type == 2 ? 'ogrnin' : 'ogrn'" v-model="entity.ogrn" v-validate="`length:${entity.type == 1 ? 13 : 15}|required`" data-vv-validate-on="blur">
                  <span class="text-danger text-sm" >{{ entity.type == 2 ? errors.first('ogrnin') : errors.first('ogrn') }}</span>
                </div>
                <h4 class="add">{{entity.type == 1 ? 'Юридический адрес' : 'Адрес проживания'}}* <a href="#" @click.prevent="$refs.adr.open(getAddress(), 'legal', entity.type == 1 ? 'Юридический адрес' : 'Адрес проживания')">Заполнить</a></h4>
                <div class="input-block">
                  <input autocomplete="off" type="text" disabled :value="getAddressString()">
                  <span class="text-danger text-sm" v-if="legal_address_error">{{legal_address_error}}</span>
                </div>
                <app-checkbox  v-model="entity.entity_address">Совпадает с {{entity.type == 1 ? 'юридическим адресом' : 'адресом проживания'}}</app-checkbox>
                <h4 class="add">Почтовый адрес <a href="#" @click.prevent="$refs.adr.open(getAddress('mail'), 'mail','Почтовый адрес') " v-if="!entity.entity_address">Заполнить</a></h4>
                <div class="input-block">
                  <input autocomplete="off" type="text" disabled :value="getAddressString('mail')">
                  <span class="text-danger text-sm" v-if="mail_address_error">{{mail_address_error}}</span>
                </div>
                <h4>Телефон*</h4>
                <div class="input-block">
                  <input autocomplete="off" type="text" v-on:blur="phoneNumber"  data-vv-validate-on="blur" name="phone" @input="entity.phone = $event.target.value" id="phone-field" ref="pfil" :value="entity.phone">
                  <span class="text-danger text-sm">{{ errors.first('phone') }}</span>
                  <span class="text-danger text-sm" v-if="error_phone && !errors.first('phone')">{{ error_phone }}</span>
                </div>
                <h4>E-mail*</h4>
                <div class="input-block">
                  <input autocomplete="off" type="text" v-validate="'required|email'" v-model="entity.email" name="email" data-vv-validate-on="blur" value="">
                  <span class="text-danger text-sm">{{ errors.first('email') }}</span>
                </div>
              </div>
              <div class="column">
                <h4 v-if="entity.type == 1">Должность*</h4>
                <div class="input-block" v-if="entity.type == 1">
                  <app-select :options="dols" v-model="entity.position"/>
                  <span class="text-danger text-sm" v-if="position_error">{{ position_error }}</span>
                </div>

                <h4>Фамилия</h4>
                <div class="input-block">
                  <input autocomplete="off" type="text" name="surname" v-model="entity.surname"  data-vv-validate-on="blur">
                  <span class="text-danger text-sm">{{ errors.first('surname') }}</span>
                </div>
                <h4>Имя</h4>
                <div class="input-block">
                  <input autocomplete="off" type="text" name="name" v-model="entity.name"  data-vv-validate-on="blur">
                  <span class="text-danger text-sm">{{ errors.first('name') }}</span>
                </div>
                <h4>Отчество</h4>
                <div class="input-block">
                  <input autocomplete="off" type="text" name="patronymic" v-model="entity.patronymic" data-vv-validate-on="blur">
                  <span class="text-danger text-sm">{{ errors.first('patronymic') }}</span>
                </div>
                <h4 v-if="entity.type == 1">Действует на основании*</h4>
                <div class="input-block" v-if="entity.type == 1">
                  <app-select :options="acts" v-model="entity.act"/>
                  <span class="text-danger text-sm">{{ errors.first('act') }}</span>
                </div>
                <template v-if="entity.act == 'Доверенность'">
                  <h4>Дата выдачи*</h4>
                  <div class="calendar">
                    <div class="input-block">
                      <!--<date-picker v-model="entity.date_issue" @change="validDate(1)"></date-picker>-->
                      <date-picker v-model="entity.date_issue"></date-picker>
                      <span class="text-danger text-sm" v-if="date_issue_error">{{date_issue_error}}</span>
                      <br>
                      <span class="text-danger text-sm" v-if="date_error">{{date_error}}</span>
                    </div>
                  </div>
                  <h4>Срок действия*</h4>
                  <div class="double">
                    <div class="double_container">
                      <date-picker v-model="entity.date_from" @change="validDate(2)"></date-picker>
                      <br>
                      <span class="text-danger text-sm" style="width: 178px; display: inline-block;" v-if="date_from_error">{{date_from_error}}</span>
                    </div>
                    <div class="double_container">
                      <date-picker v-model="entity.date_to" @change="validDate(3)"></date-picker>
                      <br>
                      <span class="text-danger text-sm" style="width: 178px; display: inline-block;" v-if="date_to_error">{{date_to_error}}</span>
                    </div>
                  </div>
                  <span class="text-danger text-sm" style="display: inline-block;" v-if="date_to_from_error">{{date_to_from_error}}</span>
                </template>

              </div>
              <add-rr-modal ref="rr" @save="rrDiagSave"/>
              <adress-modal ref="adr" @save="adressSave"/>
              <div class="column right">
                <button @click="$refs.rr.openRRModal(undefined,undefined,entity.requisites)">Добавить расчетный счет</button>
              </div>
            </div>
            <div class="wrap" v-if="!requis_loading">
              <div class="column-card" v-for="(requisite, key) in entity.requisites" :key="key">
                <div class="top">
                  <h3>{{requisite.name}}</h3>
                  <div class="buttons">
                    <button @click="$refs.rr.openRRModal(requisite, key,entity.requisites)">
                      <img class="hover_btn" src="@/assets/img/main/edit.svg" alt="">
                    </button>
                    <button @click="deleteRequisite(key)">
                      <img class="hover_btn" src="@/assets/img/main/close.svg" alt="">
                    </button>
                  </div>
                </div>
                <div class="body">
                  <div class="item">
                    <p class="bold">Р/с {{requisite.checking_account}}</p>
                    <p>{{requisite.bank}}</p>
                    <p>Бик: {{requisite.bik}}</p>
                    <p>К/с {{requisite.correspondent_account}}</p>
                  </div>
                  <div class="status">
                    <p class="active" v-if="!requisite.active">Действующий</p>
                    <p class="base" v-if="requisite.main && !requisite.active">Основной</p>
                    <p class="off" v-if="requisite.active">Неактивный</p>
                  </div>
                </div>
              </div>
            </div>
            <div class="btn">
              <button @click="submit()">Сохранить</button>
            </div>
          </div>
        </loading-container>
      </main>
</template>

<script>
    import Inputmask from 'inputmask'
    import AppSelect from "@/components/app-select";
    import AddRrModal from "@/components/modals/add-rr-modal";
    import AdressModal from "@/components/modals/adress-modal";
    import LoadingContainer from "@/components/loading-container";
    import AppCheckbox from "@/components/app-checkbox";

    export default {
        name: "add-contragent",
        components: { AppCheckbox, LoadingContainer, AdressModal, AddRrModal, AppSelect},
        data: ()=>({
            dols: ['Директор', 'Генеральный Директор'],
            acts: ['Устав', 'Доверенность'],
            tabs: [
                { title: 'Юр. лицо', key: 1, },
                { title: 'ИП', key: 2, },
            ],
            tab: [
                { title: 'Активная', key: 1, },
                { title: 'Неактивная', key: 0, },
            ],
            loading: true,
            requis_loading: false,
            entity:{
              type: 1,
              active: 1,
              company_name: '',
              inn: '',
              kpp: '',
              ogrn: '',
              phone: '',
              email: '',
              position: '',
              surname: '',
              name: '',
              patronymic: '',
              act: '',
              date_issue: '',
              entity_address: false,
              date_from: '',
              date_to: '',
              token: '',
              country: '',
              city: '',
              street: '',
              house: '',
              corps: '',
              flat: '',
              index: '',
              legal_address_country: null,
              legal_address_city : null,
              legal_address_region : null,
              legal_address_street : null,
              legal_address_house : null,
              legal_address_corps : null,
              legal_address_flat : null,
              legal_index : null,
              legal_info : null,
              mail_address_country : null,
              mail_address_city : null,
              mail_address_street : null,
              mail_address_house : null,
              mail_address_corps : null,
              mail_address_flat : null,
              mail_index : null,
              mail_info : null,
              requisites: [],
            },
            position_error: '',
            date_to_from_error: '',
            act_error: '',
            date_error: '',
            date_from_error: '',
            date_to_error: '',
            edit: '',
            country_error: '',
            city_error: '',
            street_error: '',
            house_error: '',
            corps_error: '',
            flat_error: '',
            index_error: '',
            legal_address_error: '',
            mail_address_error: '',
            date_issue_error: '',
            error_phone: '',
            initialized: false,
            dirty: false,
            escape: true
        }),
        mounted() {
          if(this.$route.name == 'companyEdit')
            this.getEntity();
          else{
            this.loading = false;
            this.initialized = true;
          }
        },
        beforeRouteLeave (to, from, next) {
          // If the form is dirty and the user did not confirm leave,
          // prevent losing unsaved changes by canceling navigation
          if (this.confirmStayInDirtyForm()){
            next(false)
          } else {
            // Navigate to next view
            next()
          }
        },
        created() {
          window.addEventListener('beforeunload', this.beforeWindowUnload)
        },
        beforeDestroy() {
          window.removeEventListener('beforeunload', this.beforeWindowUnload)
        },
        methods: {
          confirmLeave() {
            return window.confirm('Вы действительно хотите уйти? Несохраненные данные будут утеряны!')
          },

          confirmStayInDirtyForm() {
            return this.escape && this.dirty && !this.confirmLeave()
          },
          beforeWindowUnload(e) {
            if (this.confirmStayInDirtyForm()) {
              // Cancel the event
              e.preventDefault()
              // Chrome requires returnValue to be set
              e.returnValue = ''
            }
          },
          phoneNumber(){
            this.error_phone = null;
            this.error_pass = null;

            if (this.entity.phone.indexOf('_') !== -1) {
              this.error_phone = 'Поле телефон обязательно к заполнению.';
            }
          },
          validDate(type){
            if (type == 1){
              this.date_issue_error = null;
              if (this.$moment().format('YYYYMMDD') > this.$moment(this.entity.date_issue).format('YYYYMMDD') ){
                this.date_issue_error = 'Дата выдачи не может быть больше текущей';
              }
            }
            if (type == 2){
              this.date_from_error = null;
              if (this.$moment(this.entity.date_issue).unix() > this.$moment(this.entity.date_from).unix()){
                this.date_from_error = 'Сроки действия не могут быть меньше даты выдачи';
              }
              if(this.entity.date_to) {
                if (this.$moment(this.entity.date_from).unix() > this.$moment(this.entity.date_to).unix()) {
                  this.date_from_error = 'Начало срока действия не может быть больше его окончания';
                }
              }
            }
            if (type == 3){
              this.date_from_error = null;
              this.date_to_error = null;
              if (this.$moment(this.entity.date_from).unix() > this.$moment(this.entity.date_to).unix()) {
                this.date_to_error = 'Начало срока действия не может быть больше его окончания';
              }
              this.date_from_error = null;
              if (this.$moment(this.entity.date_issue).unix() > this.$moment(this.entity.date_from).unix()){
                this.date_from_error = 'Сроки действия не могут быть меньше даты выдачи';
              }
            }
          },
          tabActive(item){
            this.entity = {
                  company_name: '',
                  active: 1,
                  inn: '',
                  kpp: '',
                  ogrn: '',
                  phone: '',
                  email: '',
                  position: '',
                  surname: '',
                  name: '',
                  patronymic: '',
                  act: '',
                  date_issue: '',
                  entity_address: false,
                  date_from: '',
                  date_to: '',
                  token: '',
                  country: '',
                  city: '',
                  street: '',
                  house: '',
                  corps: '',
                  flat: '',
                  index: '',
                  legal_address_country: null,
                  legal_address_city : null,
                  legal_address_region : null,
                  legal_address_street : null,
                  legal_address_house : null,
                  legal_address_corps : null,
                  legal_address_flat : null,
                  legal_index : null,
                  legal_info : null,
                  mail_address_country : null,
                  mail_address_city : null,
                  mail_address_region : null,
                  mail_address_street : null,
                  mail_address_house : null,
                  mail_address_corps : null,
                  mail_address_flat : null,
                  mail_index : null,
                  mail_info : null,
                  requisites: [],
            };

            this.entity.type = item
          },
          init(){
            let im = new Inputmask("+7 (999) 999 99 99");
            im.mask(this.$refs.pfil);
          },
          submit(){
            if(this.$route.name == 'companyEdit')
              this.editEntity();
            else
              this.send()
          },
          getEntity() {
            if (localStorage.getItem('token')) {
              this.loading = true;
              this.$http.post('/get-entity', {
                token: localStorage.getItem('token'),
                id: this.$route.params.id
              })
                .then(({data}) => {
                  if (data.entity) {
                    this.entity = data.entity
                    this.$nextTick(() => {
                      this.initialized = true;
                    })
                 }
                })
                .catch((error) => {
                 console.log(error)
                })
              .finally(()=> this.loading = false)
            }
          },
          valid(){
            this.date_error = '';
            // this.date_from_error = '';
            // this.date_to_error = '';
            this.legal_address_error = '';
            this.mail_address_error = '';
            this.act_error = '';
            this.position_error = '';
            this.date_to_from_error = '';
            this.error_phone = '';
            console.log(this.entity.phone)
            if (this.entity.phone.indexOf('_') !== -1 || !this.entity.phone) {
              this.error_phone = 'Поле телефон обязательно к заполнению.';
            }

            // if (!this.entity.act) {
            //   this.act_error = 'Поле обязательно к заполнению';
            // }else{
            //   if(this.entity.act == 'Доверенность'){
            //     if (!this.entity.date_to) {
            //       this.date_to_error = 'Поле обязательно к заполнению';
            //     }
            //
            //     if (!this.entity.date_from) {
            //       this.date_from_error = 'Поле обязательно к заполнению';
            //     }
            //
            //     if(this.date_to_error == '' && this.date_from_error == ''){
            //       if(this.$moment(this.entity.date_to).unix() < this.$moment(this.entity.date_from).unix()){
            //         this.date_to_from_error = 'Дата окончания не может находится в прошедшем веремени'
            //       }
            //     }
            //
            //     if (!this.entity.date_issue) {
            //       this.date_error = 'Поле обязательно к заполнению';
            //     }
            //
            //   }
            // }

            // if (!this.entity.position) {
            //   this.position_error = 'Поле обязательно к заполнению';
            // }
            if (this.entity.legal_address_country == null ||
                this.entity.legal_address_city == null ||
                this.entity.legal_address_street == null ||
                this.entity.legal_address_house == null) {
              this.legal_address_error = 'Поле обязательно к заполнению';
            }
            if (this.entity.mail_address_country == null ||
                this.entity.mail_address_city == null ||
                this.entity.mail_address_street == null ||
                this.entity.mail_address_house == null)  {
              this.mail_address_error = 'Поле обязательно к заполнению';
            }
            return (
                // !this.act_error &&
                !this.error_phone && !this.date_error && !this.date_from_error && !this.date_issue_error && !this.date_to_error && !this.legal_address_error && !this.mail_address_error)
          },
          editEntity () {
              this.$validator.validateAll().then(success => {
                if (success && this.valid()) {
                  this.$http.post('/edit-company-entity', {
                    ...this.entity,
                    entity_address: Number(this.entity.entity_address),
                    id: this.$route.params.id,
                    token: localStorage.getItem('token')
                  }).then(({data}) => {
                    if (data.success) {
                      this.$toast.success('Данные успешно изменены!');
                      this.escape = false;
                      this.$router.push('/organization/profile');
                    }else if(data.error && data.message){
                      this.$toast.error(data.message);
                    }
                })
                  .catch((error) => {
                      console.log(error)
                    this.$toast.error('Ошибка!');
                  })
                }
              })
          },
          send () {
              this.$validator.validateAll().then(success => {
                if (this.valid() && success) {
                  this.loading = true;
                  this.$http.post('/add-company-entity', {
                    ...this.entity,
                    entity_address: Number(this.entity.entity_address),
                    token: localStorage.getItem('token'),
                  })
                      .then(({data}) => {
                        if (data.success) {
                          this.$toast.success('Данные успешно сохранены!');
                          this.escape = false;
                          this.$router.push('/organization/profile')
                        }else if(data.error && data.message){
                          this.$toast.error(data.message);
                        }
                      }).catch((error) => {
                    console.log(error)
                    this.$toast.error('Ошибка!');
                  })
                      .finally(()=> this.loading = false)
                }
              })
          },
          deleteRequisite (index) {
            this.entity.requisites.splice(index, 1);
          },
          rrDiagSave({data, key}){
            this.requis_loading = true;
            if(key != null){
              this.entity.requisites[key] = data
            }else{
              let flag = false;
              if(this.entity.requisites.length){
                 this.entity.requisites.forEach(el => {
                  if (data.main == true) {
                    if (el.main == true) {
                      el.main = false;
                      return el;
                    }
                  }
                })

                this.entity.requisites.forEach(el => {
                  if (flag){
                    return;
                  }

                  if (data.name != el.name){
                    flag = true;
                    this.entity.requisites.push(data)
                  }
                });
              }else{
                this.entity.requisites.push(data)
              }
            }



            this.requis_loading = false;
          },
          getAddress(type = 'legal'){
            let adress_arr = {};
            adress_arr[type +'_address_country'] = this.entity[type +'_address_country']
            adress_arr[type +'_address_city'] = this.entity[type +'_address_city']
            adress_arr[type +'_address_region'] = this.entity[type +'_address_region']
            adress_arr[type +'_address_street'] = this.entity[type +'_address_street']
            adress_arr[type +'_address_house'] = this.entity[type +'_address_house']
            adress_arr[type +'_address_corps'] = this.entity[type +'_address_corps']
            adress_arr[type +'_address_flat'] = this.entity[type +'_address_flat']
            adress_arr[type +'_index'] = this.entity[type +'_index']
            adress_arr[type +'_info'] = this.entity[type +'_info']
            return adress_arr;
          },
          getAddressString(type = 'legal'){
            if (this.entity[type +'_true'] && !this.entity.entity_address && type == 'mail'){
              this.entity.mail_true = false;
              return 'Не указано'
            }

            if(this.entity[type +'_address_country'] != null && this.entity[type +'_address_city'] != null && this.entity[type +'_address_house'] != null) {
              return `${this.entity[type + '_index'] ? this.entity[type + '_index'] + ', ' : ''}${this.entity[type + '_address_country']}, ${this.entity[type + '_address_city']}, ${this.entity[type + '_address_region'] ? this.entity[type + '_address_region'] : ''}, ул.${this.entity[type + '_address_street']}, д.${this.entity[type + '_address_house']}${this.entity[type + '_address_corps'] ? (', к.'+this.entity[type + '_address_corps']) : ''}${this.entity[type + '_address_flat'] ? ', офис '+this.entity[type + '_address_flat'] : ''}`
            }else{
              return 'Не указано'
            }
          },
          adressSave(payload){
            Object.assign(this.entity, payload)
            if(this.entity.entity_address) this.addressEquiv()
          },
          addressEquiv(){
            this.entity.mail_address_country = this.entity.legal_address_country
            this.entity.mail_address_city = this.entity.legal_address_city
            this.entity.mail_address_region = this.entity.legal_address_region
            this.entity.mail_address_street = this.entity.legal_address_street
            this.entity.mail_address_house = this.entity.legal_address_house
            this.entity.mail_address_corps = this.entity.legal_address_corps
            this.entity.mail_address_flat = this.entity.legal_address_flat
            this.entity.mail_index = this.entity.legal_index
            this.entity.mail_info = this.entity.legal_info
            this.entity.mail_true = true
          },
          changeInn(){
            if(this.$route.name != 'companyEdit') {
              let length = this.entity.type == 1 ? 10 : 12;
              if (this.entity.inn.length == length) {
                var url = "https://suggestions.dadata.ru/suggestions/api/4_1/rs/findById/party";
                var token = "04b7cf5657185c9a3d363fc6680a7fe198a65cb8";
                var query = this.entity.inn;
                let config = {
                  mode: "cors",
                  headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                    "Authorization": "Token " + token
                  },
                };

                this.$http.post(url, JSON.stringify({query: query, branch_type: 'MAIN', count: 1}), config)
                  .then(({data}) => {
                    if (this.entity.type == 1) {
                      this.entity.kpp = data.suggestions[0].data.kpp;
                    }
                    this.entity.company_name = data.suggestions[0].value;
                    this.entity.ogrn = data.suggestions[0].data.ogrn;
                    this.entity.legal_address_country = data.suggestions[0].data.address.data.country;
                    this.entity.legal_address_city = data.suggestions[0].data.address.data.city_with_type;
                    this.entity.legal_address_house = data.suggestions[0].data.address.data.house;
                    this.entity.legal_address_street = data.suggestions[0].data.address.data.street_with_type;
                    this.entity.legal_index = data.suggestions[0].data.address.data.postal_code;
                    this.entity.legal_address_flat = data.suggestions[0].data.address.data.flat;
                    this.entity.legal_address_corps = data.suggestions[0].data.address.data.block;
                  }).catch((error) => {
                      console.log(error);
                  });
                }
              }
            }
        },
        watch: {
          'entity.entity_address'(n){
            if(n){
             this.addressEquiv()
            }
          },
          entity:
          {
            handler()
            {
              if (this.initialized) {
                this.dirty = true;
              }

            },
            deep: true
          }
        }
    }
</script>
<style>
.v-select{
  margin: 0;
}
</style>
<style scoped lang="scss">
  .btn{
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    button{
      background: #2CB181;
      border-radius: 4px;
      height: 50px;
      width: 25%;
      border: none;
      font-style: normal;
      font-weight: 500;
      font-size: 14px;
      line-height: 16px;
      color: #FFFFFF;
    }
  }
  .wrap{
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    flex-wrap: wrap;
    margin-top: 20px;
    .column-card{
      padding: 17px;
      width: 49.5%;
      background: #FFFFFF;
      box-shadow: 0px 0px 3px #E5E5EA;
      border-radius: 4px;
      margin-bottom: 17px;
      &.dis{
        opacity: 0.3;
      }
      .body{
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        padding: 17px 0 10px 0;
        .item{
          text-align: left;
          p{
            font-family: Roboto;
            font-style: normal;
            font-weight: normal;
            font-size: 14px;
            line-height: 16px;
            color: #7A818F;
            margin: 5px 0;
            &.bold{
              color: #2D3137;
            }
          }
        }
        .status{
          text-align: right;
          p{
            font-family: Roboto;
            font-style: normal;
            font-weight: normal;
            font-size: 12px;
            line-height: 14px;
            color: #7A818F;
            margin-bottom: 5px;
            &.active{
              color: #2CB181;
            }
            &.base{
              color: #F39220;
            }
            &.off{
              color: #7A818F;
            }
          }
        }
      }
      .top{
        padding: 0;
        margin: 0 -17px 0 -17px;
        border-bottom: 1px solid #D5D9E0;
        height: 30px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: auto;
        h3{
          margin-top: -16px;
          margin-left: 17px;
          font-family: Roboto;
          font-style: normal;
          font-weight: 500;
          font-size: 16px;
          line-height: 19px;
          color: #2D3137;
        }
        .buttons {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-top: -16px;
          padding-right: 20px;
          button {
            height: 20px;
            border: none;
            background: none;
            cursor: pointer;
            outline: none;
            margin: 0 0 0 10px;
            > img {
              width: 100%;
              height: 100%;
            }
          }
        }
      }

    }
  }

  main {
    padding: 30px;
    width: 85%;
  }
  h4{
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 16px;
    color: #000000;
    margin: 0 0 5px 1px;
    &.add{
      display: flex;
      justify-content: space-between;
      a{
        font-family: Roboto;
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 16px;
        text-align: right;
        text-decoration-line: underline;
        color: #7A818F;
      }
    }
  }
  .double{
    display: flex;
    align-items: center;
    justify-content: space-between;

    &_container{
      width: 100%;
    }
    &_container:first-child {
      margin-right: 5px ;
    }
  }
  .right{
    display: flex;
    justify-content: flex-end;
    align-items: flex-end;
    height: 100%;
    button{
      background: #2CB181;
      border-radius: 4px;
      height: 40px;
      width: 60%;
      border: none;
      font-style: normal;
      font-weight: 500;
      font-size: 14px;
      line-height: 16px;
      color: #FFFFFF;
    }
  }
  .body{
    .top{
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      justify-content: space-between;
      width: 100%;
      margin-bottom: 10px;
      &__title{
        display: flex;
        flex-wrap: wrap;
        .name{
          display: flex;
          align-items: center;
          font-style: normal;
          font-weight: 500;
          font-size: 16px;
          line-height: 19px;
          color: #2D3137;
          margin-right: 30px;
        }
        .status{
          font-style: normal;
          font-weight: normal;
          font-size: 12px;
          line-height: 14px;
          color: #2CB181;
        }
        &-radio{
          font-style: normal;
          font-weight: normal;
          font-size: 14px;
          line-height: 16px;
          display: flex;
          width: max-content;
          background-color: white;
          border-radius: 4px;
          border: 1px solid #EEF0F3;

          &-item {
            cursor: pointer;
            padding: 10px 15px;
            margin: 2px;
            color: #7A818F;
          }
          &-item.active {
            color: #ffffff;
            background: #2cb181;
            border-radius: 4px;
          }
        }
      }
    }
    .content{
      display: flex;
      flex-wrap: wrap;
      align-items: flex-start;
      justify-content: space-between;
      width: 100%;
      input{
        font-style: normal;
        font-weight: normal;
        font-size: 12px;
        line-height: 14px;
        color: #7A818F;
        padding-left: 10px;
        width: 100%;
        height: 40px;
        background: #FFFFFF;
        border: 1px solid #EEF0F3;
        box-sizing: border-box;
        border-radius: 4px;
        &.about{
          height: 117px;
        }
        &:disabled{
          font-style: normal;
          font-weight: normal;
          font-size: 12px;
          line-height: 14px;
          color: #7A818F;
          background: #EEF0F3;
        }
      }
      .sec{
        margin-top: 126px;
      }
      .dis{
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 16px;
        color: #7A818F;
      }
      .btn{
        width: 100%;
        padding: 0;
        margin-top: 15px;
        button{
          width: 100%;
          height: 50px;
          font-style: normal;
          font-weight: 500;
          font-size: 14px;
          line-height: 16px;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #FFFFFF;
          background: #2CB181;
          border-radius: 4px;
          border: none;
        }
      }
      .password{
        position: relative;
        button{
          margin-top: 10px;
          width: 20px;
          height: 20px;
          position: absolute;
          right: 15px;
          top: 20%;
          transform: translateY(-50%);
          background-color: transparent;
          border: none;
          background-image: url('../../assets/img/main/eye.svg');
          background-position: center center;
          background-repeat: no-repeat;
          background-size: contain;
          cursor: pointer;

        }
      }
      .calendar{
        position: relative;
        button{
          margin-top: 10px;
          width: 20px;
          height: 20px;
          position: absolute;
          right: 15px;
          top: 20%;
          transform: translateY(-50%);
          background-color: transparent;
          border: none;
          background-image: url('../../assets/img/main/calendar.svg');
          background-position: center center;
          background-repeat: no-repeat;
          background-size: contain;
          cursor: pointer;

        }
      }
      .logo{
        height: 61px;
        background: #FFFFFF;
        box-shadow: 0px 0px 3px #E5E5EA;
        border-radius: 4px;
        margin-bottom: 15px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 10px 15px;
        button{
          background: #FFFFFF;
          width: 85%;
          height: 40px;
          border: 1px solid #B6BCC8;
          box-sizing: border-box;
          border-radius: 4px;
          font-style: normal;
          font-size: 12px;
          line-height: 14px;
          color: #7A818F;
          margin-left: 15px;
        }
        img{
          width: 44px;
          height: 44px;
        }
      }
    }

  }

  .input-block {
    margin-bottom: 15px;
  }

  .column{
    width: 33%;
  }

  button{
    &.big{
      height: 50px;
    }
    &:disabled{
      user-select: none;
      cursor: default !important;
      background: #B6BCC8;

      &:hover{
        background: #B6BCC8;
      }
    }

    &.outlined{
      &:hover{
        color: #2CB181;
        border-color: #2CB181;
        background: transparent;
      }
    }
    &:hover{
      background: #25966E;
    }
  }


</style>
